import { colors } from '@mmt/legacy-commons/Styles/globalStyles';
import React, { useState, useEffect, useRef } from 'react';
import { View, Text, StyleSheet, Animated } from 'react-native';

type ProgressBarProps = {
  duration: number;
  onComplete: () => void;
  renderTitle: (timeLeft: number) => React.ReactNode;
};

export const ProgressBar = ({ duration, onComplete, renderTitle }: ProgressBarProps) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const progress = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (duration && duration > 0) {
      const interval = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            onComplete();
            return 0;
          }
          return prev ? prev - 1000 : 0;
        });
      }, 1000);

      Animated.timing(progress, {
        toValue: 100,
        duration,
        useNativeDriver: false,
      }).start(() => {
        duration && duration <= 0 && onComplete();
      });

      return () => clearInterval(interval);
    }
  }, [progress]);

  const progressBarWidth = progress.interpolate({
    inputRange: [0, 100],
    outputRange: ['0%', '100%'],
  });

  return (
    <View style={styles.container}>
      <Text style={styles.timeText}>{renderTitle(timeLeft ?? 0)}</Text>
      <View style={styles.barContainer}>
        <Animated.View style={[styles.progressBar, { width: progressBarWidth }]} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  barContainer: {
    height: 8,
    backgroundColor: colors.faintgray,
    borderRadius: 4,
    overflow: 'hidden',
    justifyContent: 'center',
    marginTop: 10,
  },
  progressBar: {
    height: '100%',
    backgroundColor: colors.skyBlue8,
  },
  timeText: {
    textAlign: 'center',
    color: colors.black,
    fontWeight: 'bold',
  },
  container: {
    paddingHorizontal: 16,
    marginTop: 15,
  },
});
